// extracted by mini-css-extract-plugin
export default {"resItemTxt":"index_resItemTxt__gconU","copy":"index_copy__bUR9W"};